<app-modal>
    <ng-container modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </ng-container>
    <ng-container modal-body *ngIf="!isLoading && !isDataProcessing; else loadingAnimation">
        <div class="form-group row" *ngIf="rootPath; else noItems">
            <div class="col s12">
                <div class="app-file-manager">
                    <label for="tree" [ngClass]="labelClass">{{ label }}</label>
                    <p-tree id="tree"
                            [(value)]="items"
                            [metaKeySelection]="false"
                            selectionMode="single"
                            [(selection)]="selectedFile">
                    </p-tree>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">
            {{ 'generic.buttons.cancel' | translate }}
        </app-button>
        <app-button type="warning"
                    *ngIf="items.length > 0 && !isLoading && !isDataProcessing"
                    class="btn btn-warning"
                    (click)="updatePath()">
            {{ 'admin.tools.details.documentsPage.path-modal.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>

<ng-template #noItems>
    <div class="noItems">{{ 'admin.toolMaintenancePlans.tasks.createModal.instructionModal.noItems'| translate }}</div>
</ng-template>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
